<script>
    import { onMount } from 'svelte';
    import Icon from 'svelte-awesome';
    import { caretRight, caretDown } from 'svelte-awesome/icons'
    import Modal, { getModal } from '../../modals/OnMountModal.svelte';
    import { queryGetItemsWithSources, queryGetSources } from '../../../stores/helpers';

    import SourceItemComponent from './SourceItemComponent.svelte';
    import SourceItemCheckboxComponent from './SourceItemCheckboxComponent.svelte';
    export let showFilterItemsModal;
    export let item;
    export let changeFilteredSourceItems;
    export let addItemToFilter;
    export let filteredItems;

    let allSources = [];
    let hostname;

    $: {
        try {
            ({ hostname } = new URL(item.link));
        } catch (e) {
            ()=>{}
        }
    }

    function getUniqueLinks(items) {
        const seen = {}
        return items.filter(item => {
            if (!(item.link in seen)) {
                seen[item.link] = 1;
                return item;
            }
        })
    }
    $: currentSourceItems = hostname ? getUniqueLinks(queryGetItemsWithSources([hostname])) : [];
    $: displayItemSet = { [hostname]: 1 }
    $: shouldDisplayItems = displayItemSet[hostname];

    onMount(() => {
        allSources = queryGetSources(true);
        getModal().open(showFilterItemsModal)
    })

    function clickItem(checked, sourceName, item) {
        addItemToFilter(checked, sourceName, item)
    }

    function clickSource(checked, sourceName) {
        changeFilteredSourceItems(checked, sourceName);
    }

    function clickCaret(sourceName) {
        if (displayItemSet[sourceName]) {
            displayItemSet[sourceName] = 0;
        } else {
            displayItemSet[sourceName] = 1;
        }
    }

</script>

<Modal class="action-modal">
    <div class="filter-modal-content-container">
        <h2>Filters</h2>

        <div style="margin-bottom:40px;">
            {#if hostname}
                <div style="display:flex;padding:10px 0;">
                    <input style="width:16px;height:16px;margin:0;" type="checkbox" value="{hostname}" id="{hostname}" on:change={(e) => clickSource(e, hostname)} checked={hostname in filteredItems}>
                    <label style="padding-left:8px;" for="{hostname}">{hostname} - ({currentSourceItems?.length})</label>
                    <div on:click={clickCaret(hostname)} style="width:24px;display:flex;align-items:center;justify-content:center;">
                        {#if shouldDisplayItems}
                            <Icon data={caretDown} scale={1} />
                        {:else}
                            <Icon data={caretRight} scale={1} />
                        {/if}
                    </div>
                </div>
            {/if}

            {#if shouldDisplayItems}
                {#each currentSourceItems as item}
                    <div>
                        <SourceItemCheckboxComponent
                            item={item}
                            sourceName={hostname}
                            filteredItems={filteredItems}
                            clickItem={clickItem}
                        />
                    </div>
                {/each}
            {/if}

            {#each allSources as source}
                {#if hostname !== source[0]}
                    <SourceItemComponent 
                        source={source}
                        clickSource={clickSource}
                        clickCaret={clickCaret}
                        clickItem={clickItem}
                        displayItemSet={displayItemSet}
                        checked={source[0] in filteredItems}
                        filteredItems={filteredItems}
                    />
                    
                {/if}
            {/each}
        </div>
    </div>
    <div style="position:absolute;bottom:0;right:0;left:0;">
        <button style="width:100%;margin-bottom:0;" on:click={() => getModal().close()}>Done</button>
    </div>
</Modal>

<style>
    .filter-modal-content-container {
        max-height: 400px;
    }
    @media (max-width: 640px) {
        
    }
</style>